import { generateRepositories } from 'tests/mocks';

export const getFetchRepositories = async () => {
  return Promise.resolve([
    ...generateRepositories({
      isActive: true,
      isOrg: true,
      ownerName: 'linear-b',
      number: 5
    }),
    ...generateRepositories({
      isActive: true,
      isOrg: true,
      ownerName: 'linear-b',
      number: 2
    }),
    ...generateRepositories({
      isActive: true,
      isOrg: true,
      ownerName: 'another-linear-b',
      number: 2
    }),
    ...generateRepositories({
      isActive: false,
      isOrg: true,
      ownerName: 'another-linear-b',
      number: 10
    })
  ]);
};
